import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

// Get all cars
export const getAllCars = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/cars`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cars:', error);
    throw error;
  }
};

// Get single car by ID
export const getCarById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/api/cars/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching car:', error);
    throw error;
  }
};

// Create new car
export const createCar = async (carData) => {
  try {
    const response = await axios.post(`${API_URL}/api/cars`, carData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating car:', error);
    throw error;
  }
};

// Update car
export const updateCar = async (id, carData) => {
  try {
    const response = await axios.put(`${API_URL}/api/cars/${id}`, carData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating car:', error);
    throw error;
  }
};

// Delete car
export const deleteCar = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/api/cars/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting car:', error);
    throw error;
  }
};

// Toggle car availability
export const toggleCarAvailability = async (id) => {
  try {
    const response = await axios.patch(`${API_URL}/api/cars/${id}/toggle-availability`);
    return response.data;
  } catch (error) {
    console.error('Error toggling car availability:', error);
    throw error;
  }
};

// Get available cars for a date range
export const getAvailableCars = async (pickup_date, return_date) => {
  try {
    const response = await axios.get(`${API_URL}/api/cars`, {
      params: { pickup_date, return_date }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching available cars:', error);
    throw error;
  }
};
